<template>
  <v-layout v-show="!!getStateOrderTypes && getStateOrderTypes.length > 1 && !getDineInOnly && !$route.query.dineInOnly" pa-2 row wrap justify-center>
    <v-btn-toggle mandatory class="snappy-box">
      <div class="glider" :style="`left: ${selectedIndex * 120}px`"></div>

      <!-- active-class="white--text" -->
      <v-btn
        flat
        :disabled="dineInExistingOrder"
        v-for="item in getStateOrderTypes"
        :key="item.key" :value="item.value"
        class="orderTypeSelect"
        :class="{ 'cartSize': isCart, 'white--text': selected == item.value }"
        @click="selectOrderType(item.value)"
        large
      >
        <div v-html="$vuetify.t(item.i18n).replace('sur place', 'sur<br>place')"></div>
      </v-btn>
    </v-btn-toggle>

    <confirm-action
      :model="confirmSwitchTo"
      title="Please Confirm"
      description="Are you sure you want to switch from Dine-in ordering?"
      action-text="Yes, switch"
      color="primary"
      @confirmed="onConfirm"
      @cancel="confirmSwitchTo = false"
    />
  </v-layout>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { isNullOrEmpty } from '../services/util.service'

import ConfirmAction from '@/components/Common/ConfirmAction.vue'

export default {
  props: {
    isCart: {
      type: Boolean,
      default: () => false
    }
  },

  components: {
    ConfirmAction
  },

  data: () => ({
    confirmSwitchTo: null
  }),
  computed: {
    selected: {
      get() {
        return this.getOrderType
      },
      set(val) {
        this.setOrderType(val)
      }
    },
    selectedIndex() {
      if (isNullOrEmpty(this.getStateOrderTypes))
        return 0
      return this.getStateOrderTypes.findIndex(_item => _item.value == this.selected)
    },

    dineInExistingOrder() {
      return this.getExistingOrder.length && this.isDineIn || this.getDineInOnly
    },

    ...mapGetters([
      'isDineIn',
      'isStoreClosed',
      'testDateAgainstHours',
      'tillNextOpen',
      'getStore',
      'getOrderType',
      'getStoreOrderTypes',
      'getStateOrderTypes',
      'getExistingOrder',
      'isInKioskMode',
      'isDineIn',
      'getTableId',
      'getEnteredViaQr',
      'getDineInOnly'
    ])
  },

  methods: {
    methodAllowed(item) {
      // Dine in is always allowed
      if (item.value == "DINE_IN")
        return true

      if (this.isStoreClosed) {
        const allowOffHourPickup = this.getStore.settings.orderSettings.allowOffHourPickup
        const pickupHoursLimit = this.getStore.settings.orderSettings.scheduledOrderTimeLimitInHours

        const allowOffHourDelivery = this.getStore.settings.orderSettings.allowOffHourDelivery
        const deliveryHoursLimit = this.getStore.settings.orderSettings.scheduledDeliveryTimeLimitInHours

        if (item.value == 'PICKUP')
          return allowOffHourPickup && (this.tillNextOpen('PICKUP') - pickupHoursLimit) <= 0
        if (item.value == 'DELIVERY')
          return allowOffHourDelivery && (this.tillNextOpen('DELIVERY') - deliveryHoursLimit) <= 0
        return false
      }

      return true
    },

    async selectOrderType(newOrderType) {
      // When using dine in mode with a table set (usually via qr code), 
      // customers were apparently accidently switching so we are asking them to confirm before switching
      if (this.isDineIn && newOrderType != 'DINE_IN' && !!this.getTableId && this.getTableId != -1) {
        this.confirmSwitchTo = newOrderType
        return
      }

      this.setOrderType(newOrderType)
    },

    onConfirm() {
      this.setOrderType(this.confirmSwitchTo)
      this.confirmSwitchTo = null
    },

    ...mapActions([ 'setOrderType' ])
  }
}
</script>

<style>
  .cartSize .glider {
    height: 45px !important;
  }
</style>
<style scoped>
  .v-item-group.snappy-box {
    position: relative;
  }

  .orderTypeSelect {
    font-size: calc(var(--text-size-1) * 1.2);
    padding: 25px !important;
    width: 120px !important;
  }
  .cartSize .orderTypeSelect {
    font-size: calc(var(--text-size-1));
    padding: 0px 10px !important;
  }

  .glider {
    position: absolute;

    width: 120px;
    height: 50px;

    background-color: var(--v-primary-base);
    opacity: 0.5;

    -webkit-transition: all 0.2s ease-in-out;
    -moz-transition:    all 0.2s ease-in-out;
    -ms-transition:     all 0.2s ease-in-out;
    -o-transition:      all 0.2s ease-in-out;
    transition:         all 0.2s ease-in-out;
  }
</style>
